import React, { useState, useEffect, useRef } from "react";

import Album from "./Album.js";

import { Editor as TinyMce } from "@tinymce/tinymce-react";

import styles from "./Editor.module.less";

function Editor({ value, onChange }) {
  const [visible, setVisible] = useState(false);
  const [editor, setEditor] = useState(null);

  const onEditorChange = (val) => {
    if (onChange) {
      onChange(val);
    }
  };

  const onUploadOk = (pic) => {
    setVisible(false);
    if (editor) {
      pic.forEach((v) => {
        editor.insertContent(`<img src="${v}" />`);
      });
    }
  };

  return (
    <div className={styles.Editor}>
      <Album
        visible={visible}
        onOk={onUploadOk}
        onCancel={() => setVisible(false)}
      />
      <TinyMce
        tinymceScriptSrc="https://cdn.staticfile.org/tinymce/5.5.1/tinymce.min.js"
        initialValue={value}
        init={{
          height: 500,
          menubar: false,
          language: "zh_CN",
          language_url: "/langs/zh_CN.js",
          plugins: [
            "code link table lists image media wordcount searchreplace charmap",
          ],
          toolbar: [
            "fontselect | fontsizeselect | link unlink | removeformat | table image media | code | gallery | searchreplace",
            "bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright| indent outdent | charmap | numlist bullist | undo redo",
          ],
          font_formats:
            "宋体=宋体;黑体=黑体;微软雅黑=微软雅黑;楷体=楷体;Tahoma=tahoma,arial,helvetica,sans-serif;Times New Roman=times new roman,times;Verdana=verdana,geneva;Georgia=georgia,palatino",
          fontsize_formats: "12px 14px 16px 18px 24px 36px 48px",
          setup: (editor) => {
            editor.ui.registry.addButton("gallery", {
              icon: "gallery",
              tooltip: "图库",
              onAction: function () {
                setVisible(true);
                setEditor(editor);
              },
            });
          },
          branding: false,
        }}
        onEditorChange={onEditorChange}
      />
    </div>
  );
}

export default Editor;
